export default __webpack_public_path__ + "static/media/review.5ff161c2.png";